import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';

const GerencialMetas = lazy(() => import('./Metas'));
const GerencialMetaDetail = lazy(() => import('./MetaDetail'));
const GerencialDashboard = lazy(() => import('./Dashboard'));
const GerencialAdministracao = lazy(() => import('./Administracao'));

export const gerencialRoutes: RouteObject[] = [
    {
        path: '/gerencial/metas',
        element: (
            <ProtectedRoute permission="gerencial.view">
                <GerencialMetas />
            </ProtectedRoute>
        ),
    },
    {
        path: '/gerencial/dashboard',
        element: (
            // Dashboard é pra todo mundo do módulo — o backend recorta o que cada nível enxerga.
            <ProtectedRoute permission="gerencial.view">
                <GerencialDashboard />
            </ProtectedRoute>
        ),
    },
    {
        path: '/gerencial/metas/:id',
        element: (
            <ProtectedRoute permission="gerencial.view">
                <GerencialMetaDetail />
            </ProtectedRoute>
        ),
    },
    {
        path: '/gerencial/administracao',
        element: (
            // Gerente (vínculo, sem permissão) também entra — a página valida pelo scope do backend.
            <ProtectedRoute permission="gerencial.view">
                <GerencialAdministracao />
            </ProtectedRoute>
        ),
    },
    {
        // Deep-links da seleção do mestre-detalhe — mesma página de Administração.
        path: '/gerencial/administracao/gerencias/nova',
        element: (
            <ProtectedRoute permission="gerencial.admin">
                <GerencialAdministracao />
            </ProtectedRoute>
        ),
    },
    {
        path: '/gerencial/administracao/gerencias/:id',
        element: (
            <ProtectedRoute permission="gerencial.view">
                <GerencialAdministracao />
            </ProtectedRoute>
        ),
    },
];
